<br><br><br><br>
<div class="page-title">
  <h1 class="title-text">Feedback</h1>
  <p class="form-desc">We appreciate you taking the time to share your thoughts!</p>
</div>

<mat-card class="mat-mdc-elevation-specific mat-elevation-z8">
  <mat-card-content>
    <form [formGroup]="form" (ngSubmit)="create()">
      <br>

        <mat-form-field appearance="fill">
          <mat-label>Please provide your feedback.</mat-label>
          <textarea matInput placeholder="Enter feedback up to 5,000 characters" formControlName="feedbackBody" rows="20"></textarea>
        </mat-form-field>

        <p class="form-desc">Please Read Before Submitting Your Feedback</p>
        <br>
          <p class="form-desc">
            To ensure your privacy and the anonymity of this feedback process, <strong>do not include any Personally Identifiable Information (PII)</strong> in the text of your submission.
          </p>
          <br>
            <p class="form-desc">PII includes, but is not limited to:</p>

            <ul>
              <li>Your name or the name of any other person.</li>
              <li>E-mail addresses, phone numbers, or physical addresses.</li>
              <li>Employee IDs or Social Security Numbers.</li>
            </ul>
            <br>
              <p class="form-desc">
                Please focus your feedback on processes, policies, products, suggestions and general experiences.
              </p>

              <div class="button-container">
                <button mat-raised-button color="primary" class="submit-button">Submit</button>
              </div>

              @if (isLoading) {
                <div class="custom-spinner-container">
                  <div class="custom-spinner"></div>
                </div>
              }

            </form>
          </mat-card-content>
        </mat-card>
        <br><br>
